<div class="admin-page-container">

  <admin-toolbar class="admin-toolbar" (toggleSidebar)="toggleSidebar()" section="User Details"></admin-toolbar>

  <mat-sidenav-container id="admin-content-wrapper" class="admin-content-wrapper">

    <mat-sidenav #adminsidenav class="admin-sidebar">

      <admin-sidebar></admin-sidebar>

    </mat-sidenav>

    <mat-sidenav-content>

      <!-- [START] page content -->

      <mat-card style="width: 100%; display: block;">

        <mat-card-header>
          <mat-card-title>User Details</mat-card-title>
        </mat-card-header>

        <mat-card-content style="padding-left: 16px;">

          <p>Use the form below to update the details for a user.  Click the UPDATE button when you are ready to save your changes.</p>

          <!-- user details column -->
          <div  style="display: inline-block; width: 720px;">

            <div style="margin-bottom: 24px;">

              <h3>User Details</h3>

              <p-avatar image="{{profilePicture()}}" class="useravatar" size="xlarge">

              </p-avatar>

              <div style="display: inline-block; vertical-align: top; margin-left: 12px;">
                <div><label style="margin-right: 8px;">Files:</label><span>{{filesCount()}}</span></div>
                <div><label style="margin-right: 8px;">Disk Usage:</label><span>{{diskUsage()}}</span></div>
              </div>

            </div>

            <div [formGroup]="form">

              <!-- display_name -->

              <span class="p-float-label">

                <input
                  id="float-name"
                  class="p-inputtext p-component form-control"
                  [class.p-filled]="newUser && (newUser.display_name.trim().length > 0)"
                  formControlName="name"
                  required type="text"
                  pInputText=""
                  (change)="setName($event)">
                <label  for="float-name">Display Name</label>

                <div *ngIf="name.invalid && (name.dirty || name.touched)" style="width: 300px;display: inline-block;">

                  <small *ngIf="name.errors.required"  class="p-error">
                    Display Name can not be empty.
                  </small>
                </div>

              </span>

              <!-- first_name -->

              <span class="p-float-label">

                <input
                  id="float-firstname"
                  class="p-inputtext p-component form-control"
                  [class.p-filled]="newUser && (newUser.first_name.trim().length > 0)"
                  formControlName="firstname"
                  required type="text"
                  pInputText=""
                  (change)="setFirstName($event)">
                <label  for="float-firstname">First Name</label>

                <div *ngIf="firstname.invalid && (firstname.dirty || firstname.touched)" style="width: 300px;display: inline-block;">

                  <small *ngIf="firstname.errors.required"  class="p-error">
                    First Name can not be empty.
                  </small>
                </div>

              </span>

              <!-- last_name -->

              <span class="p-float-label">

                <input
                  id="float-lastname"
                  class="p-inputtext p-component form-control"
                  [class.p-filled]="newUser && (newUser.last_name.trim().length > 0)"
                  formControlName="lastname"
                  required type="text"
                  pInputText=""
                  (change)="setLastName($event)">
                <label  for="float-firstname">Last Name</label>

                <div *ngIf="lastname.invalid && (lastname.dirty || lastname.touched)" style="width: 300px;display: inline-block;">

                  <small *ngIf="lastname.errors.required"  class="p-error">
                    Last Name can not be empty.
                  </small>
                </div>

              </span>

              <!-- email -->

              <span class="p-float-label">

                <input
                  id="float-email"
                  class="p-inputtext p-component form-control"
                  [class.p-filled]="newUser && (newUser.email.trim().length > 0)"
                  formControlName="email"
                  required type="text"
                  (change)="setEMail($event)">
                <label  for="float-email">eMail</label>

                <div *ngIf="email.invalid && (email.dirty || email.touched)" style="width: 300px;display: inline-block;">

                  <small *ngIf="email.errors.required"  class="p-error">
                    eMail can not be empty.
                  </small>

                  <small *ngIf="email.errors.pattern"  class="p-error">
                    Invalid email value
                  </small>

                  <small *ngIf="email.errors.exists"  class="p-error">
                    eMail is already in use by another account.
                  </small>

                </div>

              </span>

              <!-- userid -->

              <span class="p-float-label">

                <input
                  id="float-userid"
                  class="p-inputtext p-component form-control"
                  [class.p-filled]="newUser && (newUser.userid.trim().length > 0)"
                  formControlName="userid"
                  required type="text"
                  pInputText=""
                  (change)="setUserid($event)">
                <label  for="float-userid">Userid</label>

                <div *ngIf="userid.invalid && (userid.dirty || userid.touched)" style="width: 300px;display: inline-block;">

                  <small *ngIf="userid.errors.required"  class="p-error">
                    Userid can not be empty.
                  </small>

                  <small *ngIf="userid.errors.pattern"  class="p-error">
                    Invalid userid value
                  </small>

                  <small *ngIf="userid.errors.exists"  class="p-error">
                    Userid is already in use by another account.
                  </small>
                </div>

              </span>


            </div>

            <button pButton type="button" label="Update" style="margin-top: 12px; color: white;" icon="pi pi-save" class="p-button-lg" [disabled]="!form.valid" (click)="save()"></button>

            <span id="savemsg" style="margin-left: 16px;">{{saveMessage}}</span>

          </div>

          <!-- password reset column -->

          <div style="margin-top: 128px; vertical-align: top; display: inline-block; width: 600px;" [formGroup]="resetForm">

              <p-password
                id="passwordforminput"
                toggleMask="true"
                feedback="true"
                width=250
                formControlName="password"
                required
                (change)="setPassword($event)">

              </p-password>

              <div style="width: 250px;">

                  <h6>Pick a password</h6>

                  <p-divider></p-divider>

                  <p class="p-mt-2">Suggestions</p>
                  <ul class="p-pl-2 p-ml-2 p-mt-0" style="line-height: 1.5">
                    <li>At least one lowercase</li>
                    <li>At least one uppercase</li>
                    <li>At least one numeric</li>
                    <li>Minimum 8 characters</li>
                  </ul>

              </div>

            <button pButton type="button" label="Reset" style="margin-top: 12px; color: white;" icon="pi pi-save" class="p-button-lg" (click)="resetPassword()"></button>

            <span style="margin-left: 16px;">{{resetMessage}}</span>

          </div>


        </mat-card-content>
      </mat-card>

      <!-- [END] page content -->

      <admin-footer section="User Details"></admin-footer>

    </mat-sidenav-content>

  </mat-sidenav-container>

</div>

